import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import AutomationStyle from "@/styles/components/automation-popup/_index.module.scss";
import Button from "@/components/button";
import ButtonStyle from "@/styles/components/button/_index.module.scss";
import {
  Form,
  Formik,
  FormikControl,
  Yup,
  ClientDashboard,
  useTranslation,
  TRANSLATION,
  InputError,
  InputText,
  FormStyle,
  useRouter,
} from "@/imports-files/common/common";
import {
  reviewAutomationEmail,
  sendQuestions,
} from "@/imports-files/pages/clients/candidates/kanban";
import { FormModalStyle } from "@/imports-files/components/review-email";
import { Close } from "@/imports-files/components/common-modal/common-modal";

export function SendQuestionModal(props) {
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const initialValues = props.selectedCards;
  initialValues.send_question_details = { expires: "" };
  initialValues.job_id = props.job_id;
  const validationSchema = Yup.object().shape({
    send_question_details: Yup.object().shape({
      expires: Yup.string().required(TRANSLATION("errors:required")),
    }),
  });

  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal}`}>
        <div className={`${FormModalStyle.Modal__Container}`}>
          <div className = {`${FormModalStyle.Modal__Container__Heading__Close}`}>
           <h1
              className={`${FormModalStyle.Modal__Container__ContentSection__Heading} `}
            > {t("jobs:options:screening:heading")}</h1>
            <div
              className={`${FormModalStyle.Modal__Container__CloseSection}`}
              onClick={() => props.setBtnPopup(false)}>
              <Close />
            </div>
          </div>
          <div
            className={`${FormModalStyle.Modal__Container__ContentSection} `}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={async (values, actions) => {
                await sendQuestions(
                  values,
                  props.setBtnPopup,
                  props.from,
                  props.setLoading,
                  props.setJobData || props.setInitialData,
                  {
                    activeTab: props.activeTab,
                    setSelectedCards: props.setSelectedCards,
                    setActionBar: props.setActionBar,
                  }
                );
              }}
            >
              {(formik) => (
                <Form>
                    <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${FormStyle.Form__TableCol} `}
                    >
                      <label className={`${FormStyle.Form__FloatingLabel}`} style={InputText(
                          formik,
                          `send_question_details.expires`
                        )}><span className={`red-color`}>*</span> &nbsp;{t("label:expiry_days")}</label>
                      <FormikControl
                        className={`${FormModalStyle.Form__Input}`}
                        control="input"
                        type="text"
                        autocomplete="off"
                        placeholder="e g. 15"
                        formik={formik}
                        maxLength={3}
                        custom_class={`FieldError`}
                        name={`send_question_details.expires`}
                        value={formik.values.send_question_details.expires}
                        onChange={(evt) => {
                          let new_value = isNaN(evt.target.value)
                            ? ""
                            : parseInt(evt.target.value) == 0
                            ? ""
                            : evt.target.value;
                          formik.setFieldValue(
                            `send_question_details.expires`,
                            new_value
                          );
                        }}
                        style={InputError(
                          formik,
                          `send_question_details.expires`
                        )}
                      ></FormikControl>
                    </div>
                    <div
                      className={`${FormModalStyle.Modal__Container__ButtonSection} `}
                    >
                      <Button
                        buttonstyle={`${ButtonStyle.secondarybtn}`}
                        type="button"
                        onClick={async () => {
                          let data = await reviewAutomationEmail(
                            props.job_id,
                            router,
                            { key: "send_screening_questions", list: true }
                          );
                          props.setEmailData(data);
                          props.setHideModalClass(true);
                          props.setEmailTemplateInfo(props.emailTemplateInfo);
                          props.setReviewEmail(true);
                        }}
                      >
                       {t("button:review_email")}
                      </Button>
                      <Button
                        buttonstyle={`${ButtonStyle.primarybtn}`}
                        type="submit"
                      >
                        {t("button:send_questions")}
                      </Button>
                    </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

SendQuestionModal.layout = ClientDashboard;
export default SendQuestionModal;
